import { useState } from 'react';

export function createLoadingState() {
    const [state, setLoadingState] = useState<boolean>(false);

    const isLoading = (): boolean => state;

    const load = (): void => setLoadingState(true);

    const loaded = (): void => setLoadingState(false);

    return {
        state,
        isLoading,
        load,
        loaded,
    };
}
